import { useState, useEffect } from 'react';
import {
    CommonGridHeaderOnlySearch, renderInsCorpDetails, CommonPopUp
} from '../../Components/Common Components/CommonComponents';
import RestAPIService from '../../Utility/Services/RestAPIService';
import {
    Box, Button, FormControl, InputLabel, MenuItem, Modal, Select, Tooltip, Typography,
    Table, TableHead, TableRow, TableCell, TableBody, TableContainer
} from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';
import { Colors } from '../../Styles/Colors';
import { DataGrid } from '@mui/x-data-grid';
import { labelMap } from '../../Utility/Constants';
import OgttGraph from '../../Modules/Laboratory/HomeTab/OgttGraph';


const LabHistoryPopup = (props) => {
    const [state, setState] = useState({
        selectedImageRowId: null,
        uploadData: [],
        isViewHistory: false,
        viewCultureData: [],
        testName: "",
        isViewOgtt: false,
        viewOgttData: {},
        selectedOgttRowId: null,
        page: 0,
        pageSize: 10,
        insuToolOpen: true,
    })

    useEffect(() => {
        const timer = setTimeout(() => {
            updateState({ insuToolOpen: undefined });
        }, 2000);
        return () => clearTimeout(timer);
    }, [])

    const updateState = (newData) => {
        setState((prevState) => ({
            ...prevState,
            ...newData
        }))
    }

    const getS3Key = async (doc_key, id) => {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + doc_key);

            if (response.data.status === "success") {
                const Data = response.data;
                return {
                    data_url: Data.data,
                    id: id,
                    type: doc_key?.split('.')?.pop() === "pdf" ? "pdf" : "image"
                };
            }
        } catch (e) {
            props.errorMessage("Error fetching S3 URL")
        }
    }

    const sourceOpen = async (list) => {
        let tempArr = [];
        let image = list?.result_image ? JSON.parse(list.result_image) : []
        if (image !== null) {
            for (let j = 0; j < image?.length; j++) {
                let doc_key = image[j];
                let id = list.id;
                let getData = await getS3Key(doc_key, id);
                tempArr.push(getData);
            }
            updateState({
                sourceOpen: true,
                selectedUploadData: list,
                uploadedImages: tempArr,
                selectedImage: null,
            });
        }
    }

    const ogttTestView = () => {
        let { isViewOgtt, isViewGraph, viewOgttData, testName } = state;
        const { normal_range = [], result = {} } = viewOgttData || {};
        return (
            <Modal sx={{ border: "none", outline: "none" }} open={isViewOgtt}>
                <Box className='emedhub_popup' sx={{ width: "65vw", height: "fit-content" }}>
                    <div className=''>
                        <div className='emedhub_popup_title'>
                            <label className='emedhub_popup_title_left'>Test Report</label>
                            <div className='emedhub_card_close_button'>
                                <img
                                    className='emedhub_popup_title_right'
                                    src={ImagePaths.LabCloseButton.default}
                                    onClick={() => {
                                        updateState({
                                            isViewOgtt: false,
                                            selectedOgttRowId: null,
                                            isViewGraph: false
                                        })
                                    }}
                                    alt='close'
                                />
                            </div>
                        </div>
                        <div className='emedhub_popup_title_2' style={{ marginTop: "0.5vw", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", gap: "1vw", alignItems: "center" }}>
                                <Typography sx={{ whiteSpace: "nowrap" }}>{`OGTT Test - ${testName}`}</Typography>
                                <FormControl size="small" fullWidth>
                                    <InputLabel id="glucose-type-select-label">Glucose Type</InputLabel>
                                    <Select
                                        labelId="glucose-type-select-label"
                                        value={result?.value?.glucose_type_selection || ""}
                                        label="Glucose Type"
                                        sx={{ width: "10vw" }}
                                        disabled
                                    >
                                        <MenuItem value="">-- Select --</MenuItem>
                                        <MenuItem value="75">75gms</MenuItem>
                                        <MenuItem value="100">100gms</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <Button variant='contained'
                                onClick={() => { updateState({ isViewGraph: !state.isViewGraph }) }}
                                sx={{ textTransform: "capitalize" }}>
                                {isViewGraph ? "Back" : "View Graph"} </Button>
                        </div>
                    </div>
                    <div style={{ width: "100%", height: "20vw", marginTop: "1vw" }}>
                        {isViewGraph ? <OgttGraph ogttData={result?.value} />
                            : renderOgttTbl(result?.value, {
                                is_fasting: normal_range[0]?.is_fasting,
                                is_30min: normal_range[0]?.is_30min,
                                is_1hr: normal_range[0]?.is_1hr,
                                is_1_5hr: normal_range[0]?.is_1_5hr,
                                is_2hr: normal_range[0]?.is_2hr,
                                is_2_5hr: normal_range[0]?.is_2_5hr,
                                is_3hr: normal_range[0]?.is_3hr
                            })}
                    </div>
                </Box>
            </Modal>
        )
    }

    const renderOgttTbl = (data, ogttConfig) => {
        const keys = Object.keys(ogttConfig).filter(key => ogttConfig[key]);
        return (
            <TableContainer sx={{ width: "100%", height: "100%" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7", fontWeight: "bold" }}>Hour</TableCell>
                            {keys.map((item) => (<TableCell size='small' sx={{ backgroundColor: "#F5F8F7", fontWeight: "bold" }} key={item}>{labelMap[item]}</TableCell>))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Blood Glucose</TableCell>
                            {keys.map((key) => (
                                <TableCell key={key}>{data['bloodGlucose'][key]}</TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            <TableCell>Urine Glucose</TableCell>
                            {keys.map((key) => {
                                const value = data['urineGlucose'][key];
                                return (
                                    <TableCell key={key}>{value?.length > 20 ?
                                        <Tooltip arrow title={value}>
                                            <div>{value.slice(0, 20) + "..."}</div>
                                        </Tooltip> : value || "-"}</TableCell>
                                )
                            })}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>)
    }

    const PopUpClose = () => {
        updateState({
            isViewHistory: false,
            viewCultureData: [],
            testName: "",
        })
    }

    const viewCultureTest = (data) => {
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "47vh",
                overflowY: "auto",
            }}
            >
                {data?.map((items, indexs) => {
                    return (
                        <div key={indexs} style={{ width: "70vw", marginBottom: "1vw" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "1vw", marginBottom: "1vw" }}>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <Box component={'div'} sx={{ display: "flex" }}>
                                        <Typography>{`ORGANISM ISOLATED 0${indexs + 1} : `}</Typography>
                                        <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                            {items?.bacteria ? items?.bacteria?.length > 20 ?
                                                <Tooltip placement='top' title={items?.bacteria} arrow>
                                                    <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                                        {items?.bacteria.slice(0, 20) + '...'}
                                                    </Typography>
                                                </Tooltip> :
                                                <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.bacteria}</Typography> : '-'}
                                        </Typography>
                                    </Box>
                                </div>
                                <Box component={'div'} sx={{ display: "flex" }}>
                                    <Typography>{`MICROSCOPY : `}</Typography>
                                    <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                        {items?.microscopy ? items?.microscopy?.length > 20 ?
                                            <Tooltip placement='top' title={items?.microscopy} arrow>
                                                <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                                    {items?.microscopy.slice(0, 20) + '...'}
                                                </Typography>
                                            </Tooltip> :
                                            <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.microscopy}</Typography> : '-'}
                                    </Typography>
                                </Box>
                                <Box component={'div'} sx={{ display: "flex" }}>
                                    <Typography>{`COLONY COUNT : `}</Typography>
                                    <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                        {items?.colony_count ? items?.colony_count?.length > 20 ?
                                            <Tooltip placement='top' title={items?.colony_count} arrow>
                                                <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                                    {items?.colony_count.slice(0, 20) + '...'}
                                                </Typography>
                                            </Tooltip> :
                                            <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.colony_count}</Typography> : '-'}
                                    </Typography>
                                </Box>
                                <Box component={'div'} sx={{ display: "flex" }}>
                                    <Typography>{`METHOD : `}</Typography>
                                    <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                        {items?.method_type ? items?.method_type?.length > 20 ?
                                            <Tooltip placement='top' title={items?.method_type} arrow>
                                                <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>
                                                    {items?.method_type.slice(0, 20) + '...'}
                                                </Typography>
                                            </Tooltip> :
                                            <Typography sx={{ fontWeight: 600, marginLeft: "0.3vw" }}>{items?.method_type}</Typography> : '-'}
                                    </Typography>
                                </Box>
                            </div>
                            <TableContainer style={{ maxHeight: "35vh" }}>
                                <Table style={{ border: "1px solid gray" }} stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"SNo"}</b></TableCell>
                                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Antibiotic"}</b></TableCell>
                                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"MIC Result/Range"}</b></TableCell>
                                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Zone Result/Range"}</b></TableCell>
                                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Interpretaion"}</b></TableCell>
                                            <TableCell size='small' sx={{ backgroundColor: "#F5F8F7" }}><b>{"Efficiency Ration"}</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {items?.antibacteria?.length > 0 ?
                                            items?.antibacteria?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>
                                                        {item?.antibiotic ? item?.antibiotic?.length > 20 ?
                                                            <Tooltip placement='top' title={item?.antibiotic} arrow>
                                                                <Typography>
                                                                    {item?.antibiotic.slice(0, 20) + '...'}
                                                                </Typography>
                                                            </Tooltip> :
                                                            <Typography>{item?.antibiotic}</Typography> : '-'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                                            <Typography>{item?.mic_break_point ? item?.mic_break_point?.length > 20 ?
                                                                <Tooltip placement='top' title={item?.mic_break_point} arrow>
                                                                    <div>{item?.mic_break_point.slice(0, 20) + '...' + " "}</div>
                                                                </Tooltip> : (item?.mic_break_point + " ") : '-'}</Typography>
                                                            {item?.mic_break_point_std ?
                                                                <Typography style={{ marginLeft: "0.25vw" }}>{item?.mic_break_point_std ? item?.mic_break_point_std?.length > 20 ?
                                                                    <Tooltip placement='top' title={item?.mic_break_point_std} arrow>
                                                                        <div>{" / " + item?.mic_break_point_std.slice(0, 20) + '...'}</div>
                                                                    </Tooltip> : (" / " + item?.mic_break_point_std) : '-'}</Typography> : null}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                                            <Typography>{item?.zone_size ? item?.zone_size?.length > 20 ?
                                                                <Tooltip placement='top' title={item?.zone_size} arrow>
                                                                    <div>{item?.zone_size.slice(0, 20) + '...' + " "}</div>
                                                                </Tooltip> : (item?.zone_size + " ") : '-'}</Typography>
                                                            {item?.zone_size_std ?
                                                                <Typography style={{ marginLeft: "0.25vw" }}>{item?.zone_size_std ? item?.zone_size_std?.length > 20 ?
                                                                    <Tooltip placement='top' title={item?.zone_size_std} arrow>
                                                                        <div>{" / " + item?.zone_size_std.slice(0, 20) + '...'}</div>
                                                                    </Tooltip> : (" / " + item?.zone_size_std) : '-'}</Typography> : null
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        {item?.interpretation ? item?.interpretation?.length > 20 ?
                                                            <Tooltip placement='top' title={item?.interpretation} arrow>
                                                                <Typography>
                                                                    {item?.interpretation.slice(0, 20) + '...'}
                                                                </Typography>
                                                            </Tooltip> :
                                                            <Typography>{item?.interpretation}</Typography> : '-'}
                                                    </TableCell>
                                                    <TableCell>
                                                        {item?.methodThreeBacteriaResult ? item?.methodThreeBacteriaResult?.length > 20 ?
                                                            <Tooltip placement='top' title={item?.methodThreeBacteriaResult} arrow>
                                                                <Typography>
                                                                    {item?.methodThreeBacteriaResult.slice(0, 20) + '...'}
                                                                </Typography>
                                                            </Tooltip> :
                                                            <Typography>{item?.methodThreeBacteriaResult}</Typography> : '-'}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                            : <TableRow>
                                                <TableCell align="center" colSpan={6}>No Records To Be Shown</TableCell>
                                            </TableRow>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )
                })}
            </div>
        )
    }

    try {
        const { labHistoryData, openPopup, labPatientData } = props
        labHistoryData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            { field: 'sno', headerName: 'S.No', flex: 0.05 },
            {
                field: 'test_date', headerName: 'Order Date And Time', flex: 0.2,
                renderCell: (params) => (
                    <Box component={'div'}>{params?.row?.test_date ? params?.row?.test_date : '-'}</Box>
                )
            },
            {
                field: 'test_name', headerName: 'Test Name', flex: 0.3,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.test_name ? params?.row?.test_name?.length > 25 ?
                        <Tooltip placement='top' title={params?.row?.test_name}>
                            <Typography>{params?.row?.test_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
                        <Typography>{params?.row?.test_name}</Typography> : '-'}
                </Box>)
            },
            {
                field: 'status', headerName: 'Result', flex: 0.3,
                renderCell: ({ row }) => (
                    (row?.is_outsource && row?.result_image) ? <div>
                        <Button
                            variant='contained'
                            sx={{ textTransform: "capitalize" }}
                            onClick={() => {
                                updateState({ selectedImageRowId: row.id, uploadData: row })
                                sourceOpen(row, row.id)
                            }}>{"View PDF"}
                        </Button>
                    </div> :
                        (row?.method === "Culture Test Result" && row?.result?.value?.length > 0) ?
                            <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }}
                                onClick={() => {
                                    updateState({
                                        isViewHistory: true,
                                        viewCultureData: row?.result?.value?.length > 0 ? row?.result?.value : [],
                                        testName: row.test_name,
                                    })
                                }}>{"View Culture History"}</Button>
                            : (row?.method === "OGTT" && row?.result?.value && Object.keys(row?.result?.value)?.length > 0) ?
                                <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }}
                                    onClick={() => {
                                        updateState({
                                            selectedOgttRowId: row.id,
                                            isViewOgtt: true,
                                            viewOgttData: row,
                                            testName: row.test_name,
                                        })
                                    }}>{"View OGTT History"}</Button> :
                                <Box component={'div'}>{row?.result?.value?.length > 20 ?
                                    <Tooltip placement='top' title={row?.result?.value} arrow><div>{row?.result?.value?.slice(0, 20) + "..."}</div></Tooltip>
                                    : row?.result?.value ? row?.result?.value
                                        : (row?.status === "Result Completed" || row?.status === "Result Delivered") ?
                                            "Result Not Entered"
                                            : "Result yet to complete"}</Box>)
            },
            {
                field: 'comments', headerName: 'Comments', flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.result?.comment ? params?.row?.result?.comment?.length > 25 ?
                        <Tooltip placement='top' title={params?.row?.result?.comment}><Typography>{params?.row?.result?.comment?.slice(0, 25) + '...'}</Typography></Tooltip> :
                        <Typography>{params?.row?.result?.comment}</Typography> : '-'}
                </Box>)
            },
        ]
        return (
            <Box component={'div'}>
                <Modal open={openPopup}>
                    <Box component={'div'} className='eMed_lab_history_popup'>
                        <Box component={'div'} height={'7vh'} pl={'1vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Patient History</Typography>
                            <Button onClick={() => { props.onClose() }}>
                                <Box component={'img'} src={ImagePaths.Close.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <Box component={'div'} borderTop={'1px solid lightgray'} p={'0.5vw'}>
                            <Typography fontSize={'0.8vw'} color={Colors.grayShade}>Patient Details</Typography>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>{labPatientData?.patient_name || labPatientData?.first_name || "-"}
                                <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`(${labPatientData?.patient_age})`}</Typography>
                                {renderInsCorpDetails(labPatientData, state.insuToolOpen)}
                            </Typography>
                            <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{`${labPatientData?.patient_account_number} | `}
                                <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{labPatientData?.patient_mobile_number || labPatientData?.mobile_number}</Typography>
                            </Typography>
                        </Box>
                        <Box component={'div'} p={'0.5vw'}>
                            <DataGrid
                                columns={columns}
                                rows={labHistoryData}
                                getRowId={(row) => row['sno']}
                                sx={{ height: '58dvh' }}
                                pageSizeOptions={[10, 20, 30]}
                                pagination
                                paginationMode="client"
                                paginationModel={{
                                    page: state.page,
                                    pageSize: state.pageSize
                                }}
                                onPaginationModelChange={(model) => {
                                    updateState({
                                        page: model.page,
                                        pageSize: model.pageSize
                                    })
                                }}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                components={{
                                    Toolbar: CommonGridHeaderOnlySearch.CommonToolBarOnlySearch,
                                    NoRowsOverlay: () => (
                                        <Box height="100%" display={'flex'} alignItems="center" justifyContent="center">
                                            No Records Found
                                        </Box>
                                    )
                                }}
                                headerHeight={40}
                                disableRowSelectionOnClick
                            />
                        </Box>
                    </Box>
                </Modal>
                {ogttTestView()}
                {
                    state.isViewHistory ?
                        <CommonPopUp width={"75vw"}
                            backgroundColor={Colors.white}
                            popUpClose={PopUpClose.bind(this)}
                            title={state.testName}
                            component={viewCultureTest.bind(this, state.viewCultureData)} />
                        : null
                }

            </Box>
        )
    } catch (error) {
        props.errorMessage(error.message)
    }
}

export default LabHistoryPopup